import {GET_CYCLE_START, GET_CYCLE_SUCCESS, GET_CYCLE_ERROR} from "../../types";

export default function cycle(state, action) {
    switch (action.type) {
        case GET_CYCLE_START:
            return {
                ...state,
                data: [],
                loading: true,
                error: null
            };
        case GET_CYCLE_SUCCESS:
            return {
                ...state,
                data: action.results,
                loading: false,
                error: null
            };
        case GET_CYCLE_ERROR:
            return {
                ...state,
                data: [],
                loading: false,
                error: action.detail
            };
        default:
            return { ...state };
    }
}